import {OfferSettingResponseBody} from '../types';

const MOCK_SETTING_ID = 'a1b2c3d4-5678-9101-1121-314151617181';
const MOCK_BRANCH_ID = '659b8f3b-4923-4d2c-8938-a2e397a5c2c3';

const offerSettingResponseMock: OfferSettingResponseBody = {
  id: MOCK_SETTING_ID,
  branchId: MOCK_BRANCH_ID,
  validityEnabled: true,
  validityDays: 30,
};

export const salesContextSettingsApiMock = {
  offerSettingResponseMock,
};
